<template>
  <div>
    <section class="solution-head">
      <div class="main-content">
        <h2>解决方案</h2>
        <p>为企业提供专业的一站式解决方案，让效率更高</p>
      </div>
    </section>

    <section class="solution-content">
      <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="leaveHandler">
        <el-tab-pane v-for="(tab,index) in tabs" :key="index" :label="tab.name" :name="index+''"
                     class="tab-pane-content">

          <section v-for="(content,idx) in tab.contents" :key="idx"
                   v-bind:style="{background:idx%2==0?'#fff':'#f9f9f9'}" style="padding: 40px 0;height: 506px;">
            <div class="main-content" :id="content.subKey">
              <h1 class="solution-content-title">{{content.title}}</h1>
              <p class="solution-content-subTitle">{{content.subTitle}}</p>

              <div class="home_hot_content">

                <video class="wow" controls
                       controlsList="nodownload"
                       preload="none"
                       v-if="content.videoUrl != ''"
                       :poster="content.poster"
                       :src="content.videoUrl"
                       v-bind:style="{float:idx%2==0?'left':'right',marginRight:idx%2==0?'40px':'0',boxShadow: idx%2==0?'6px 10px 20px rgba(45, 68, 151,0.2)':'-6px 10px 20px rgba(45, 68, 151,0.2)'}"></video>

                <img :src="content.poster"
                     v-if="content.videoUrl == ''"
                     v-bind:style="{float:idx%2==0?'left':'right',marginRight:idx%2==0?'40px':'0',boxShadow: idx%2==0?'6px 10px 20px rgba(45, 68, 151,0.2)':'-6px 10px 20px rgba(45, 68, 151,0.2)'}"/>

                <div class="wow">
                  <div class="hot_content_scenario">
                    <p><span class="title_mark"></span>适用行业场景</p>
                    <div class="scenario_div" v-for="(_scenario,idx) in content.scenario" :key="idx"
                         v-bind:class="_scenario.color" v-html="_scenario.type"></div>
                  </div>

                  <div class="hot_content_correlation">
                    <p><span class="title_mark"></span>相关产品
                      <i v-if="content.correlation.length > 6 && isFirst" class="el-icon-arrow-right" @click="whichShow('right')"></i>
                      <i v-if="content.correlation.length > 6 && !isFirst" class="el-icon-arrow-left" @click="whichShow('left')"></i></p>

                    <div class="correlation_divs" v-if="content.correlation.length <= 6">
                      <div class="correlation_div" style="display:inline-block"
                           v-for="(_correlation,idx) in content.correlation" :key="idx"
                           v-bind:style="{marginRight:idx%2==0?'16px':'0'}">
                        <router-link :to="{path: '/product#'+_correlation.to}"
                                     @click.native="scrollTo(_correlation)">
                          <i class="sudoku-product-1" v-bind:class="_correlation.logo"></i>
                          <span>{{_correlation.title}}</span>
                        </router-link>
                      </div>
                    </div>

                    <div class="correlation_divs" v-if="content.correlation.length > 6 && isFirst">
                      <div class="correlation_div" style="display:inline-block"
                           v-for="(_correlation,idx) in content.correlation.slice(0,6)" :key="idx"
                           v-bind:style="{marginRight:idx%2==0?'16px':'0'}">
                        <router-link :to="{path: '/product#'+_correlation.to}"
                                     @click.native="scrollTo(_correlation)">
                          <i class="sudoku-product-1" v-bind:class="_correlation.logo"></i>
                          <span>{{_correlation.title}}</span>
                        </router-link>
                      </div>
                    </div>
                    <div class="correlation_divs" v-if="content.correlation.length > 6 && !isFirst">
                      <div class="correlation_div" style="display:inline-block"
                           v-for="(_correlation,idx) in content.correlation.slice(6,content.correlation.length+1)" :key="idx"
                           v-bind:style="{marginRight:idx%2==0?'16px':'0'}">
                        <router-link :to="{path: '/product#'+_correlation.to}"
                                     @click.native="scrollTo(_correlation)">
                          <i class="sudoku-product-1" v-bind:class="_correlation.logo"></i>
                          <span>{{_correlation.title}}</span>
                        </router-link>
                      </div>
                    </div>

                    <div class="correlation_button text-center" v-if="content.pdfUrl!='no'"><span v-on:click="openPDF(content)">查看方案详情</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </el-tab-pane>
      </el-tabs>

      <div class="fix_top" @click="toTop">
        <img :src="top" width="20" height="20"/>
        <p>回到顶部</p>
      </div>
    </section>

  </div>
</template>

<script>
  import Bus from '../assets/bus.js'
  import {WOW} from 'wowjs'

  import finance_1 from '../assets/img/solution/finance-1.png'
  import finance_2 from '../assets/img/solution/finance-2.png'
  import finance_3 from '../assets/img/solution/finance-3.png'
  import finance_4 from '../assets/img/solution/finance-4.png'
  import finance_5 from '../assets/img/solution/finance-5.png'
  import finance_6 from '../assets/img/solution/finance-6.png'
  import finance_7 from '../assets/img/solution/finance-7.png'
  import finance_8 from '../assets/img/solution/finance-8.png'
  import store_1 from '../assets/img/solution/store-1.png'
  import store_2 from '../assets/img/solution/store-2.png'
  import city_1 from '../assets/img/solution/city-1.png'
  import MBA_1 from '../assets/img/solution/MBA-1.png'
  import MBA_2 from '../assets/img/solution/MBA-2.png'
  import common_1 from '../assets/img/solution/common-1.png'
  import common_2 from '../assets/img/solution/common-2.png'
  import common_3 from '../assets/img/solution/common-3.png'
  import top from '../assets/img/top.png'

  import C1 from "../assets/videos/C1_1.mp4";
  import C7 from "../assets/videos/C7.mp4";
  import C15 from "../assets/videos/C15.mp4";
  import E1 from "../assets/videos/E1.mp4";
  import E2 from "../assets/videos/E2.mp4";
  import E3 from "../assets/videos/E3.mp4";
  import E6 from "../assets/videos/E6.mp4";
  import E7 from "../assets/videos/E7.mp4";
  import E8 from "../assets/videos/E8.mp4";

  export default {
    name: 'Solution',
    mounted() {
      new WOW({live: false}).init()
      var _this = this;
      var hashIDEle;
      Bus.$on('hash_solution', function (value) {
        this.$nextTick(function () {
          _this.setActiveName(value.activeName + '');

        })
        hashIDEle = document.getElementById(value.subKey);

        if (hashIDEle) {
          window.scrollTo(0, hashIDEle.getBoundingClientRect().top)
        }
      })

      this.activeName = this.$route.params.activeName + '';
      hashIDEle = document.getElementById(this.$route.params.subKey);

      if (hashIDEle) {
        window.scrollTo(0, hashIDEle.getBoundingClientRect().top)
      }

    },
    updated () {
      if (this.firstRender && jQuery.isEmptyObject(this.$route.params)) {
        $('div#tab-0').addClass('is-active');
        $('div#pane-0').show();
      }
    },
    data(){
      return {
        firstRender: true,
        isFirst: true,
        activeName: '0',
        top: top,
        tabs: [{
          name: '金融服务',
          key: 'finance',
          contents: [{
            title: '智能电话客服整体解决方案',
            subKey: 'E1',
            subTitle: '智能电话客服整体解决方案可解决客户体验不理想 人力成本高、人工效车低、风险监测滞后等问题，优体验降成本',

            scenario: [{
              type: '金融<br/>客服',
              color: 'scenario_type-4'
            }, {
              type: '金融<br/>电销',
              color: 'scenario_type-2'
            }, {
              type: '贷款<br/>信审',
              color: 'scenario_type-5'
            }, {
              type: '贷款<br/>催收',
              color: 'scenario_type-1'
            }],

            correlation: [{
              title: 'A1 一站式数字电话平台服务',
              logo: 'sudoku-A1',
              to: 'A1'
            }, {
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'B1 通用客服作业系统',
              logo: 'sudoku-B1',
              to: 'B1'
            }, {
              title: 'C2 智能坐席助手',
              logo: 'sudoku-C2',
              to: 'C2'
            }, {
              title: 'C3  电话客服实时监控(情绪/话术)',
              logo: 'sudoku-C3',
              to: 'C3'
            }, {
              title: 'C4 智能质检系统',
              logo: 'sudoku-C4',
              to: 'C4'
            }, {
              title: 'C5 智能语音交互',
              logo: 'sudoku-C5',
              to: 'C5'
            }],
            videoUrl: E1,
            poster: finance_1,
            pdfUrl: '/e_seal_web/static/pdf/E1智能电话客服整体解决方案.pdf'
          }, {
            title: '视频报案查勘解决方案',
            subKey: 'E2',
            subTitle: '双方视频直面事故现场，减少用户等待查勘时间，优化用户体验；图片识别技术智能定损，系统智能化精确计算赔付金额',

            scenario: [{
              type: '车险<br/>公司',
              color: 'scenario_type-1'

            }, {
              type: '产险<br/>公司',
              color: 'scenario_type-3'
            }],

            correlation: [{
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'D2 视频坐席',
              logo: 'sudoku-D2',
              to: 'D2'
            }],

            videoUrl: E7,
            poster: finance_5,
            pdfUrl: '/e_seal_web/static/pdf/E2视频报案查勘解决方案-20181207.pdf'
          }, {
            title: '智能视频客服解决方案',
            subKey: 'E3',
            subTitle: '在线远程办理保单业务，视频双录，公安联网核实身份，电子签名确认等风控技术支持，合理规避风险，提升用户体验',

            scenario: [{
              type: '保险<br/>行业',
              color: 'scenario_type-3'
            }],

            correlation: [{
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'D2 视频坐席',
              logo: 'sudoku-D2',
              to: 'D2'
            }],

            videoUrl: E8,

            poster: finance_6,
            pdfUrl: '/e_seal_web/static/pdf/E3智能视频客服解决方案.pdf'
          }, {
            title: '知识管理整体解决方案',
            subKey: 'E4',
            subTitle: '结合客户画像、交互轨迹、大数据分析、智能搜索、知识图谱等新技术，提供精准优质的个性化知识服务',

            scenario: [{
              type: '保险<br/>行业',
              color: 'scenario_type-3'
            }, {
              type: '银行',
              color: 'scenario_type-2'
            }, {
              type: '信用卡',
              color: 'scenario_type-5'
            }, {
              type: '客服<br/>中心',
              color: 'scenario_type-6'
            }, {
              type: '电话<br/>中心',
              color: 'scenario_type-4'
            }],

            correlation: [{
              title: 'C1 智能知识平台',
              logo: 'sudoku-C1',
              to: 'C1'
            }, {
              title: 'D6 知识梳理',
              logo: 'sudoku-D6',
              to: 'D6'
            }],

            videoUrl: C1,

            poster: finance_7,
            pdfUrl: '/e_seal_web/static/pdf/E4知识管理整体解决方案-20181205.pdf'
          }, {
            title: '智能文本机器人解决方案',
            subKey: 'E5',
            subTitle: '深耕金融行业，几十万语料积累，丰富的实施经验及管理方法论，可扩展的基础架构，支持多渠道和多对象的问答交互',

            scenario: [{
              type: '贷款<br/>获客',
              color: 'scenario_type-3'
            }, {
              type: '理财<br/>营销',
              color: 'scenario_type-4'
            }, {
              type: '客服<br/>回访',
              color: 'scenario_type-2'
            }],

            correlation: [{
              title: 'C7 文本机器人',
              logo: 'sudoku-C7',
              to: 'C7'
            }, {
              title: 'D6 知识梳理',
              logo: 'sudoku-D6',
              to: 'D6'
            }],

            videoUrl: C7,

            poster: finance_8,
            pdfUrl: '/e_seal_web/static/pdf/E5智能文本机器人解决方案.pdf'
          }, {
            title: '智能催收解决方案',
            subKey: 'E6',
            subTitle: '智能催收解决方案可应用于全业务、全客群、全周期催收场景，可提供全包/半包合作、应用工具/系统及相应高效策略',

            scenario: [{
              type: '金融<br/>公司',
              color: 'scenario_type-1'
            }, {
              type: '银行',
              color: 'scenario_type-2'

            }, {
              type: '消费<br/>信贷',
              color: 'scenario_type-3'
            }, {
              type: '互联网<br/>金融',
              color: 'scenario_type-4'
            }, {
              type: '贷后<br/>管理',
              color: 'scenario_type-1'
            }],

            correlation: [{
              title: 'A1 一站式数字电话平台服务',
              logo: 'sudoku-A1',
              to: 'A1'
            }, {
              title: 'A2 智能电话机',
              logo: 'sudoku-A2',
              to: 'A2'
            }, {
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'B2 催收系统',
              logo: 'sudoku-B2',
              to: 'B2'
            }, {
              title: 'C1 智能知识平台',
              logo: 'sudoku-C1',
              to: 'C1'
            }, {
              title: 'C3 电话客服实时监控',
              logo: 'sudoku-C3',
              to: 'C3'
            }],

            videoUrl: E3,
            poster: finance_2,
            pdfUrl: '/e_seal_web/static/pdf/E6智能催收整体解决方案.pdf'
          }, {
            title: '智能信审解决方案',
            subKey: 'E7',
            subTitle: '针对借款人信用审核采用线上视频面审的方式，应用远程核身风控技术，及反欺诈评分系统减少欺诈风险和坏账率',

            scenario: [{
              type: '小额<br/>贷款',
              color: 'scenario_type-2'
            }, {
              type: '互联网<br/>金融',
              color: 'scenario_type-4'
            }, {
              type: '网贷<br/>平台',
              color: 'scenario_type-1'
            },],

            correlation: [{
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'C2 智能坐席助手',
              logo: 'sudoku-C2',
              to: 'C2'
            }, {
              title: 'C3 电话客服实时监控(情绪/话术)',
              logo: 'sudoku-C3',
              to: 'C3'
            }, {
              title: 'C4 智能质检系统',
              logo: 'sudoku-C4',
              to: 'C4'
            }, {
              title: 'D2 视频坐席',
              logo: 'sudoku-D2',
              to: 'D2'
            }],

            videoUrl: E6,
            poster: finance_4,
            pdfUrl: '/e_seal_web/static/pdf/E7智能信审解决方案.pdf'
          }, {
            title: '智能电销解决方案',
            subKey: 'E8',
            subTitle: '提供电销全流程、整体解决方案，多种智能工具及策略辅助，助力您的业务高效运转',

            scenario: [{
              type: '贷款<br/>获客',
              color: 'scenario_type-3'
            }, {
              type: '理财<br/>营销',
              color: 'scenario_type-4'
            }, {
              type: '客服<br/>回访',
              color: 'scenario_type-2'
            }],

            correlation: [{
              title: 'A1 一站式数字电话平台服务',
              logo: 'sudoku-A1',
              to: 'A1'
            }, {
              title: 'B3 通用电销系统',
              logo: 'sudoku-B3',
              to: 'B3'
            }, {
              title: 'C5 智能语音交互',
              logo: 'sudoku-C5',
              to: 'C5'
            }, {
              title: 'C8 智能消息',
              logo: 'sudoku-C8',
              to: 'C8'
            }, {
              title: 'D1 电话坐席',
              logo: 'sudoku-D1',
              to: 'D1'
            }],

            videoUrl: '',//todo
            poster: finance_3,
            pdfUrl: 'no'
          }]
        }, {
          name: '门店服务',
          key: 'store',
          contents: [{
            title: '门店智能服务终端解决方案',
            subKey: 'E9',
            subTitle: '辅助/取代门店前台人员，向到店客户提供服务；辅助/取代质检人员，全量客观对柜台服务质量进行评价',

            scenario: [{
              type: '办事<br/>大厅',
              color: 'scenario_type-1'
            }, {
              type: '银行<br/>线下网点',
              color: 'scenario_type-4'
            }, {
              type: '保险<br/>线下网点',
              color: 'scenario_type-3'
            }, {
              type: '证券<br/>线下网点',
              color: 'scenario_type-2'
            }, {
              type: '运营<br/>商线下网点',
              color: 'scenario_type-5'
            }, {
              type: '服务<br/>中心',
              color: 'scenario_type-4'
            }],

            correlation: [{
              title: 'C4 智能质检系统',
              logo: 'sudoku-C4',
              to: 'C4'
            }, {
              title: 'C15 智能门店服务机器人',
              logo: 'sudoku-C15',
              to: 'C15'
            }, {
              title: 'C16 柜面客户满意度分析机器人',
              logo: 'sudoku-C16',
              to: 'C16'
            }],

            videoUrl: C15,

            poster: store_1,
            pdfUrl: '/e_seal_web/static/pdf/E9门店智能服务终端解决方案.pdf'
          }, {
            title: '智能一体机解决方案',
            subKey: 'E10',
            subTitle: '提供电销全流程、整体解决方案，多种智能工具及策略辅助，助力您的业务高效运转',

            scenario: [{
              type: '金融<br/>门店',
              color: 'scenario_type-2'
            }, {
              type: '办事<br/>窗口',
              color: 'scenario_type-4'
            }],

            correlation: [{
              title: 'A1 一站式数字电话平台服务',
              logo: 'sudoku-A1',
              to: 'A1'
            }, {
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'A4 智能一体机',
              logo: 'sudoku-A4',
              to: 'A4'
            }],

            videoUrl: '',

            poster: store_2,
            pdfUrl: 'no'
          }]
        }, {
          name: '城市服务',
          key: 'city',
          contents: [{
            title: '智慧交通市民服务整体解决方案',
            subKey: 'E11',
            subTitle: '提供智能语音导航及业务操作系统，自主研发，模型准确率起点高，业务经验丰富，系统兼容性好',

            scenario: [{
              type: '政务<br/>热线',
              color: 'scenario_type-3'
            }, {
              type: '交警<br/>热线',
              color: 'scenario_type-4'
            }],

            correlation: [{
              title: 'A1 一站式数字电话平台服务',
              logo: 'sudoku-A1',
              to: 'A1'
            }, {
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'B1 通用客服作业系统',
              logo: 'sudoku-B1',
              to: 'B1'
            }, {
              title: 'C1 智能知识平台',
              logo: 'sudoku-C1',
              to: 'C1'
            }, {
              title: 'C4 智能质检系统',
              logo: 'sudoku-C4',
              to: 'C4'
            }, {
              title: 'C5 智能语音交互',
              logo: 'sudoku-C5',
              to: 'C5'
            }, {
              title: 'C7 文本机器人',
              logo: 'sudoku-C7',
              to: 'C7'
            }, {
              title: 'C8 智能消息',
              logo: 'sudoku-C8',
              to: 'C8'
            }],

            videoUrl: E2,

            poster: city_1,
            pdfUrl: '/e_seal_web/static/pdf/E11智慧交通市民服务整体解决方案.pdf'
          }]
        }, {
          name: '企业管理及员工服务',
          key: 'mba',
          contents: [{
            title: '企业内部核心风控整体解决方案（采购、法务、印章、财务）',
            subKey: 'E12',
            subTitle: '抽取各类型文档中需专业人员审核的关键字段和条款，并自动与关联材料及扫描件进行比对，辅助作业人员识别潜在风险，提高企业财务风控和办事效率',

            scenario: [{
              type: '财务<br/>部门',
              color: 'scenario_type-3'
            }, {
              type: '政府<br/>部门',
              color: 'scenario_type-1'
            }, {
              type: '重要文件<br/>管理',
              color: 'scenario_type-2'
            }, {
              type: '大量文本<br/>处理',
              color: 'scenario_type-5'
            }, {
              type: '合同<br/>管理',
              color: 'scenario_type-4'
            }],

            correlation: [{
              title: 'A4 智能一体机',
              logo: 'sudoku-A4',
              to: 'A4'
            }, {
              title: 'C6 印章管理平台',
              logo: 'sudoku-C6',
              to: 'C6'
            }, {
              title: 'C13 智能财务合同风控及标注平台',
              logo: 'sudoku-C13',
              to: 'C13'
            }, {
              title: 'C14 电子签章平台',
              logo: 'sudoku-C14',
              to: 'C14'
            }, {
              title: 'C17 智能法律顾问系统',
              logo: 'sudoku-C17',
              to: 'C17'
            }, {
              title: 'D5 合同及文档语义标注',
              logo: 'sudoku-D5',
              to: 'D5'
            }],

            videoUrl: '',//todo

            poster: MBA_1,
            pdfUrl: '/e_seal_web/static/pdf/E12企业内部核心风控整体解决方案（采购、法务、印章、财务）.pdf'
          }, {
            title: '员工HR智能服务解决方案',
            subKey: 'E13',
            subTitle: '提供线上自助为主的“991”服务模式，随时随地未企业内部员工提供人事服务，智能化、线上化、集中化解决员工全职生涯周期中的各类问题',

            scenario: [{
              type: '银行',
              color: 'scenario_type-3'
            }, {
              type: '国企',
              color: 'scenario_type-4'
            }, {
              type: '事业<br/>单位',
              color: 'scenario_type-2'
            }, {
              type: '大型<br/>集团',
              color: 'scenario_type-1'
            }],

            correlation: [{
              title: 'B4 HR-X企业人事服务系统',
              logo: 'sudoku-B4',
              to: 'B4'
            }, {
              title: 'C18  HR共享服务中心',
              logo: 'sudoku-C18',
              to: 'C18'
            }],

            videoUrl: '',//todo

            poster: MBA_2,
            pdfUrl: 'no'
          }]
        }, {
          name: '通用服务',
          key: 'commom',
          contents: [{
            title: '智能回访解决方案',
            subKey: 'E14',
            subTitle: '简单业务自动语音回访替代人工，降低成本；高风险业务视频回访，控制风险',

            scenario: [{
              type: '金融<br/>回访',
              color: 'scenario_type-1'
            }, {
              type: '保险<br/>行业',
              color: 'scenario_type-1'
            }],

            correlation: [{
              title: 'A1 一站式数字电话平台服务',
              logo: 'sudoku-A1',
              to: 'A1'
            }, {
              title: 'A3 一站式多媒体视频平台服务',
              logo: 'sudoku-A3',
              to: 'A3'
            }, {
              title: 'C5 智能语音交互',
              logo: 'sudoku-C5',
              to: 'C5'
            }],

            videoUrl: '',//todo

            poster: common_1,
            pdfUrl: '/e_seal_web/static/pdf/E14智能回访解决方案.pdf'
          }, {
            title: '智能标注及训练整体解决方案',
            subKey: 'E15',
            subTitle: '高效智能的标注工具+稳定专业的标注人力外包服务',

            scenario: [{
              type: '智能<br/>机器人',
              color: 'scenario_type-1'
            }, {
              type: '数据<br/>服务',
              color: 'scenario_type-4'
            }, {
              type: '众包<br/>平台',
              color: 'scenario_type-3'
            }],

            correlation: [{
              title: 'C11 智能语义标注平台',
              logo: 'sudoku-C11',
              to: 'C11'
            }, {
              title: 'C12 智能语音标注平台',
              logo: 'sudoku-C12',
              to: 'C12'
            }, {
              title: 'D3 人工语音标注(音转字)',
              logo: 'sudoku-D3',
              to: 'D3'
            }, {
              title: 'D4  人工语义标注（智能语音、文本机器人应用等）',
              logo: 'sudoku-D4',
              to: 'D4'
            }],

            videoUrl: '',//todo

            poster: common_2,
            pdfUrl: '/e_seal_web/static/pdf/E15智能话机解决方案.pdf'
          }, {
            title: '智能话机解决方案',
            subKey: 'E16',
            subTitle: '以最低的成本、最便捷的方式、无需大规模的改造，实现传统办公电话的智能语音分析应用，可进行舆情监控/热点分析/合规监控',

            scenario: [{
              type: '金融<br/>公司',
              color: 'scenario_type-1'
            }, {
              type: '银行',
              color: 'scenario_type-2'
            }, {
              type: '消费<br/>信贷',
              color: 'scenario_type-3'
            }, {
              type: '互联网<br/>金融',
              color: 'scenario_type-4'
            }, {
              type: '贷后<br/>管理',
              color: 'scenario_type-5'
            }],

            correlation: [{
              title: 'C4 智能质检系统',
              logo: 'sudoku-C4',
              to: 'C4'
            }, {
              title: '特定型号话机',
              logo: 'sudoku-call',
              to: ''//todo
            }],

            videoUrl: '',//todo

            poster: common_3,
            pdfUrl: '/e_seal_web/static/pdf/E16智能标注及训练整体解决方案.pdf'
          }]
        }]
      }
    },
    methods: {
      handleClick(key, keyPath) {

        var video = document.getElementsByTagName('video');
        if (video.length > 0) {// && !video[0].paused

          for (var i = 0, j = video.length; i < j; i++) {
            if (!video[i].paused) video[i].pause();
          }
        }
      },
      leaveHandler (activeName, oldActiveName) {
        if (oldActiveName == 'undefined' && this.firstRender) {
          $('div#tab-0').removeClass('is-active');
          $('div#pane-0').removeAttr('aria-hidden').css('display', 'none');
          this.firstRender = false;
        }

        return true;
      },
      scrollTo(item){


      },
      setActiveName(idx){
        this.activeName = idx
      },
      toTop(){
        window.scrollTo(0, 0)
      },
      openPDF(ctnt){
        const url = window.origin + ctnt.pdfUrl;
        window.open(url, '_blank');
        return false;
      },
      whichShow(dir){
          if(dir == 'left'){
              this.isFirst = true
          }else if(dir == 'right'){
              this.isFirst = false
          }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Solution.vue